<template>
  <div class="f1-standings-view" :key="'standing'">
    <div class="f1-standings-view__col">
      <h3 class="f1-standings-view__headline">
        {{$t('seasonBox.driversStandings')}}
      </h3>
      <div class="f1-standings-view__table-container">
        <table class="season-table f1-standings-view__table">
          <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">{{$t('seasonBox.driver')}}</th>
            <th scope="col">{{$t('seasonBox.team')}}</th>
            <th scope="col">{{$t('seasonBox.points')}}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="driver in championship.drivers" :key="`driver-${driver.id}`" :class="{ 'is-mercedes' : isMercedesBenzTeam(driver)}">
            <td>{{driver.position}}</td>
            <td>
              <driver-link :is-team-member="isMercedesBenzTeam(driver)"
                           :driver-firstname="driver.firstname"
                           :driver-surname="driver.surname">
              </driver-link>
            </td>
            <td>{{getDriverTeamName(driver)}}</td>
            <td>{{driver.points ? driver.points : 0}} {{driver.points === 1 ? $t('seasonBox.pt') : $t('seasonBox.pts')}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="f1-standings-view__col">
      <h3 class="f1-standings-view__headline">
        {{$t('seasonBox.constructorsStandings')}}
      </h3>
      <div class="f1-standings-view__table-container">
        <table class="season-table f1-standings-view__table">
          <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">{{$t('seasonBox.team')}}</th>
            <th scope="col">{{$t('seasonBox.engine')}}</th>
            <th scope="col">{{$t('seasonBox.points')}}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="team in championship.teams" :key="`team-${team.id}`" :class="{ 'is-mercedes' : team.foreignId.toString() === '817'}">
            <td>{{team.position}}</td>
            <td>{{team.name}}</td>
            <td>{{team.engineName}}</td>
            <td>{{team.points ? team.points : 0}} {{team.points === 1 ? $t('seasonBox.pt') : $t('seasonBox.pts')}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DriverLink from './DriverLink.vue';
import { GetterTypes } from '../store';

export default {
  components: {
    DriverLink,
  },
  methods: {
    getTeamForDriver (driver, teamId = null) {
      const event = this.getPreviousRaceResults;
      let response = null;
      let scopeTeamId = teamId;

      if (event.length > 0 && !scopeTeamId) {
        event.forEach((result) => {
          if (result.driver_ID === driver.foreignId) {
            scopeTeamId = result.team_ID;
          }
        });
      }

      if (this.championship.teams.length > 0 && scopeTeamId) {
        this.championship.teams.forEach((team) => {
          if (team.foreignId === scopeTeamId) {
            response = team;
          }
        });
      }

      return response;
    },
    getDriverTeamName (driver) {
      const team = this.getTeamForDriver(driver);
      return team
        ? team.name
        : '';
    },
    isMercedesBenzTeam (driver) {
      const team = this.getTeamForDriver(driver);
      return team && team.foreignId === '817';
    },
  },
  computed: {
    ...mapGetters([
      GetterTypes.getPreviousRaceResults,
      GetterTypes.championship,
    ]),
  },
};
</script>

<style lang="scss">
  @import "../styles/components/standingsView";
</style>
